import type { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import {
  faBriefcase,
  faChartMixed,
  faGraduationCap,
  faPersonWalking,
  faStopwatch,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

import type { ActivityType } from "api/services/treatment/schemas/ScheduleWeek";
import { theme } from "theme";

function getIcon(type: ActivityType): IconDefinition {
  switch (type) {
    case "exercise": {
      return faPersonWalking;
    }
    case "functionality": {
      return faStopwatch;
    }
    case "lesson": {
      return faGraduationCap;
    }
    case "payment": {
      return faBriefcase;
    }
    case "report": {
      return faChartMixed;
    }
    default:
      return faPersonWalking;
  }
}

const COLORS: Record<ActivityType, { background: string; color: string }> = {
  activity: { background: theme.colors.redesign.b10, color: theme.colors.redesign.b100 },
  exercise: { background: theme.colors.redesign.o10, color: theme.colors.redesign.o100 },
  functionality: { background: theme.colors.redesign.y10, color: theme.colors.redesign.y100 },
  lesson: { background: theme.colors.redesign.g10, color: theme.colors.redesign.g100 },
  payment: { background: theme.colors.redesign.b10, color: theme.colors.redesign.b100 },
  report: { background: theme.colors.redesign.p10, color: theme.colors.redesign.p100 },
};

interface ActivityIconProps {
  type: ActivityType;
}

export const ActivityIcon: React.FC<ActivityIconProps> = ({ type }) => {
  return (
    <Container style={{ backgroundColor: COLORS[type].background }}>
      <FontAwesomeIcon icon={getIcon(type)} color={COLORS[type].color} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 8px;
`;
